import api from '@/api/api';
import store from '@/store/store';
import nativeCom from '@/utils/modules/utils.native.common.js';
import nativeIf from '@/utils/modules/utils.native.interface.js';

export default {
	kss: function (url) {
		api.dashboard
      .getSsoToken()
      .then(function (data) {
        if(data && data.token && data.userIdEnc){
          var ssoUrl = 'http://ksos.kyowon.co.kr?userId='+data.userIdEnc+'&token='+data.token;
          // var ssoUrl = 'http://10.1.97.5:5150?userId='+data.userIdEnc+'&token='+data.token;

          if(url) {
            ssoUrl += '&path='+encodeURIComponent(url);
          }
          nativeIf.outbound.outlink(ssoUrl)
        } else {
            // alert("SSO연동에 실패 하였습니다.")
            nativeIf.outbound.outlink("https://ksos.kyowon.co.kr"+url);
        }
      })
      .catch(function (error) {
          alert(error.rtMsg);
      });

	},
	cubig: function (url) {
		var authTocken = store.getters.authToken;
    var deviceUuid = nativeCom.getDevideUuid();
    var sendUrl = "http://cubig.kyowon.co.kr/csportal.do?method=interfaceValidAuthRedirect&deviceUuid="+deviceUuid+"&authToken="+authTocken;
    sendUrl += "&retUrl="+encodeURIComponent(url);
    nativeIf.outbound.outlink(sendUrl);
	},
}
